import { ElementType } from 'react'
import { useLocation, useNavigate } from 'react-router'
import { Nav } from 'rsuite'

type Props = {
  id: string
  link?: string
  name: string
  icon: ElementType
  active?: boolean
  disabled?: boolean
}

const normalizePath = (path?: string): string => {
  if (!path) return ''
  const sanitizedPath = path.split('#')[0].split('?')[0]
  if (sanitizedPath.length > 1 && sanitizedPath.endsWith('/')) {
    return sanitizedPath.slice(0, -1)
  }
  return sanitizedPath
}

const NavItem = ({ id, link, name, icon: Icon, active, disabled }: Props) => {
  const location = useLocation()
  const navigate = useNavigate()
  const isActive = normalizePath(location.pathname) === normalizePath(link)

  return (
    <Nav.Item
      eventKey={id}
      className={active ? 'active' : ''}
      active={isActive}
      onClick={() => link && navigate(link)}
      icon={<Icon className="rs-sidenav-item-icon rs-icon" />}
      disabled={disabled}
    >
      <span className="sidenav-item__text">{name}</span>
    </Nav.Item>
  )
}
export default NavItem
